import { defineComponent as _defineComponent } from 'vue'
import { getLotStatusClass } from "@/helpers/status";
  import { formatDate } from "@/helpers/date";
  import { LotStatus } from "@/enums/LotStatus";
  import { computed, ref, watch } from "vue";
  import { getFirstLastName } from "@/helpers/user";
  import {
    formatPrice,
    formatStripePrice,
  } from "@/helpers/transformation/price";
  import eoiApi from "@/services/api/eoiApi";
  import router from "@/router";
  import { isInitialHoldDisabled } from "@/helpers/initialHold/isInitialHoldDisabled";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotLifecycle',
  props: {
    lot: {
      type: Object,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const paymentRequest = ref(true);

  const getStepStatus = computed(() => {
    return props.lot.status === LotStatus.OFFLINE &&
      props.lot.offlineSale?.salePhase === LotStatus.EOI
      ? LotStatus.HOLD
      : props.lot.status === LotStatus.EOI
      ? LotStatus.PRE_CONTRACT
      : props.lot.status;
  });

  const getPreContractOrHoldStatus = computed(() => {
    return props.lot.status === LotStatus.OFFLINE &&
      props.lot.offlineSale?.salePhase === LotStatus.EOI
      ? LotStatus.HOLD
      : LotStatus.PRE_CONTRACT;
  });

  watch(
    () => props.lot,
    (lot) => {
      if (lot.buyerId && lot.eoiId) {
        getInvoice();
      }
    }
  );
  const depositFromInvoice = ref(0);
  const getHoldStatus = () => (isInitialHoldDisabled() ? [] : [LotStatus.HOLD]);

  const lotStatusList = computed(() => {
    return [
      LotStatus.NOT_RELEASED,
      LotStatus.AVAILABLE,
      ...getHoldStatus(),
      LotStatus.EOI,
      LotStatus.CONTRACT_EXECUTED,
      LotStatus.UNCONDITIONAL,
      props.lot.status === LotStatus.OPTION
        ? props.lot.status === LotStatus.OPTION
          ? LotStatus.OPTION
          : LotStatus.OFFLINE
        : LotStatus.SETTLED,
    ];
  });
  const currentStatusIndex = computed(() => {
    return props.lot
      ? lotStatusList.value.findIndex(
          (value) =>
            value ===
            (props.lot.status === LotStatus.OFFLINE
              ? props.lot.offlineSale.salePhase
              : props.lot.status)
        )
      : -1;
  });
  const getInvoice = () => {
    const params = {
      eoiId: props.lot.eoiId._id,
      operationType: "payment request",
      operationStatus: "ok",
      paymentQueueId: props.lot.eoiId?.paymentQueueData?.paymentQueueId,
    };

    eoiApi
      .getInvoice(params)
      .then((response) => {
        if (response.data.length) {
          depositFromInvoice.value = response.data[0].data.amount;
          paymentRequest.value = true;
        } else {
          paymentRequest.value = false;
        }
      })
      .catch(() => {
        paymentRequest.value = false;
      });
  };
  const moveToTheContactDetailsPage = () => {
    if (props.lot?.eoiId?.customerId) {
      router.push({
        name: "ContactDetails",
        params: { id: props.lot?.eoiId?.customerId },
      });
    }
  };

  function getStatusItemClass(index: number, status: LotStatus) {
    const displayStatus =
      status === LotStatus.EOI ? getPreContractOrHoldStatus.value : status;

    return [
      index === currentStatusIndex.value
        ? getLotStatusClass(displayStatus)
        : "",
      index < currentStatusIndex.value ? "lifecycle-success" : "",
    ];
  }

const __returned__ = { props, paymentRequest, getStepStatus, getPreContractOrHoldStatus, depositFromInvoice, getHoldStatus, lotStatusList, currentStatusIndex, getInvoice, moveToTheContactDetailsPage, getStatusItemClass, get getLotStatusClass() { return getLotStatusClass }, get formatDate() { return formatDate }, get LotStatus() { return LotStatus }, computed, ref, watch, get getFirstLastName() { return getFirstLastName }, get formatPrice() { return formatPrice }, get formatStripePrice() { return formatStripePrice }, get eoiApi() { return eoiApi }, get router() { return router }, get isInitialHoldDisabled() { return isInitialHoldDisabled } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})